// ProductPage.js
import React, { useEffect, useState } from 'react';
import ProductList from './ProductList';
import ProductModal from './ProductModal';
import { demoUpcycled } from '../../../data/demoProducts';
import { PRODUCTS_URL } from '../../../config';

const UpCycledProducts = () => {
  const [data, setData] = useState(demoUpcycled);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const url = PRODUCTS_URL;

  const fetchImageData = async () => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const fetchedData = await response.json();
  
      if (fetchedData && Array.isArray(fetchedData.products)) {
        // Upcycled = linked to the upcycled collection
        // (collection link first, legacy brand string as fallback)
        const upcycledProducts = fetchedData.products.filter((product) =>
          (product.productCollection?.name || product.brand || '')
            .toUpperCase()
            .includes('UPCYCLED')
        );
        setData(upcycledProducts.length ? upcycledProducts : demoUpcycled);
      } else {
        setData(demoUpcycled);
      }
    } catch (error) {
      console.error('Failed to fetch products:', error);
      // API unreachable — show demo products instead of endless skeletons
      setData(demoUpcycled);
    }
  };
  

  useEffect(() => {
    fetchImageData();
  }, []); // Empty dependency array to ensure it only runs once on mount

  return (
    <div>
      <ProductList
        data={data}
        setSelectedProduct={setSelectedProduct}
        setShowModal={setShowModal}
      />
      {showModal && selectedProduct && (
        <ProductModal
          showModal={showModal}
          setShowModal={setShowModal}
          product={selectedProduct}
        />
      )}
    </div>
  );
};

export default UpCycledProducts;
